import { PANEL_HEIGHT } from "Areas/Documents/documentDetails/actionPanel";
import { APP_SIZES } from "Common/componentUtils/constants";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { SidebarMenuList } from "../../Common";
import buildMethodSidebarItems from "../utils/buildMethodSidebarItems";
import buildRunMethodsError from "../utils/buildRunMethodsError";
import MethodsBottomPanel from "./methodsBottomPanel";
import locale from "./tabMethods.locale";
const onItemClick = (item) => {
    item.onItemClick && item.onItemClick();
};
export default function TabMethods(props) {
    const popoverRefs = useRef({});
    useEffect(() => {
        if (props.methodsPanelRef) {
            props.methodsPanelRef.current = {
                hideConfirmations: () => {
                    forEach(popoverRefs.current, popover => {
                        var _a;
                        try {
                            if ((_a = popover.current) === null || _a === void 0 ? void 0 : _a.instance.element().isConnected)
                                popover.current.instance.hide();
                        }
                        catch (ex) {
                            console.warn(ex);
                        }
                    });
                }
            };
        }
    }, []);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    const handleRunMethods = useCallback((documentId, data) => {
        if (!props.documentObjects || !props.activeDocumentType)
            return;
        props.onBeforeRunMethods && props.onBeforeRunMethods();
        const invalidMessage = buildRunMethodsError(props.documentObjects, data);
        if (!invalidMessage) {
            props.onRunMethods && props.onRunMethods(documentId, props.activeDocumentType, data);
        }
        else {
            props.showError && props.showError(invalidMessage);
        }
    }, [
        props.onBeforeRunMethods,
        props.onRunMethods,
        props.documentObjects,
        props.activeDocumentType,
        props.showError
    ]);
    const sidebarMenuItems = useMemo(() => {
        popoverRefs.current = {};
        return props.availableMethods &&
            props.availableMethodsMap &&
            props.selectedNodesSource &&
            props.documentObjects
            ? buildMethodSidebarItems(props.availableMethods, props.availableMethodsMap, props.selectedNodesSource, props.showHints, props.readOnlyMode, popoverRefs, props.canRunMethods && props.canAddToQueue
                ? (method, nodesSource) => {
                    props.onSetMethodSelected && props.onSetMethodSelected(method, nodesSource, true);
                }
                : undefined, props.canRunMethods
                ? (method, nodesSource) => {
                    props.activeDocumentId &&
                        handleRunMethods(props.activeDocumentId, [{ method, nodesSource }]);
                }
                : undefined, props.runOnItemClick)
            : undefined;
    }, [
        props.documentObjects,
        props.canRunMethods,
        props.canAddToQueue,
        props.readOnlyMode,
        props.availableMethods,
        props.availableMethodsMap,
        props.selectedNodesSource,
        props.showHints,
        props.canAddToQueue,
        props.activeDocumentId,
        props.activeDocumentType,
        props.onSetMethodSelected,
        props.runOnItemClick,
        handleRunMethods
    ]);
    const emptyText = isEmpty(props.selectedNodesSource)
        ? locale.SELECT_OBJECT
        : isEmpty(props.availableMethods)
            ? locale.NO_AVAILABLE_METHODS
            : "";
    return (React.createElement(React.Fragment, null,
        React.createElement(SidebarMenuList, { className: props.className, colorDefault: props.colorDefault, colorHover: props.colorHover, colorActive: props.colorActive, bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, actionIconColor: props.actionIconColor, hasOutsideIndents: props.hasOutsideIndents, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: emptyText, filterText: props.filterText, sortBy: props.sortBy, sortOrder: props.sortOrder, onItemClick: onItemClick, margin: true }),
        props.canAddToQueue && props.canRunMethods && (React.createElement(MethodsBottomPanel, { menuExpanded: props.isExpanded, menuExpandedHeight: `calc(100vh - ${APP_SIZES.HEADER_HEIGHT + PANEL_HEIGHT}px)`, activeDocumentId: props.activeDocumentId, onRunMethods: handleRunMethods, onSetMethodSelected: props.onSetMethodSelected }))));
}
TabMethods.defaultProps = {
    canAddToQueue: true,
    showHints: true,
    hasOutsideIndents: true
};
